// Mock data for CardAssist Online — Indian credit cards, transactions, milestones, offers, merchant intel.

export const USER = {
  id: 'u-001',
  name: 'Aarav Mehta',
  email: 'aarav.mehta@example.com',
  initials: 'AM',
  goal: 'travel',
  joined: '2024-01-15',
};

export const CARDS = [
  {
    id: 'card-infinia',
    bank: 'HDFC Bank',
    name: 'Infinia',
    tier: 'Metal',
    network: 'VISA',
    type: 'rewards',
    design: 'graphite-gold',
    last4: '4821',
    annualFee: 12500,
    feeWaiver: 1000000,
    pointValueINR: 1.0,
    currency: 'Reward Points',
    welcomeBonus: '12,500 points on fee payment',
    bestFor: ['Dining', 'Travel (SmartBuy)', 'Grocery', 'Insurance'],
    rates: [
      { category: 'Dining', rate: 5, unit: '5x RP per ₹150', cap: 0 },
      { category: 'Travel (SmartBuy)', rate: 10, unit: '10x RP per ₹150', cap: 75000 },
      { category: 'Insurance', rate: 3.3, unit: '3.3x RP per ₹150', cap: 0 },
      { category: 'Grocery', rate: 3.3, unit: '3.3x RP per ₹150', cap: 0 },
      { category: 'Fuel', rate: 0, unit: 'Excluded', cap: 0 },
    ],
    milestones: [
      { name: 'Club Marriott Membership', target: 800000, current: 642500, reward: 'Free membership' },
      { name: 'Bonus Reward Points', target: 500000, current: 489000, reward: '10,000 RP' },
    ],
    benefits: ['Unlimited international lounges', 'Golf privileges', 'Concierge'],
  },
  {
    id: 'card-atlas',
    bank: 'Axis Bank',
    name: 'Atlas',
    tier: 'Travel',
    network: 'VISA',
    type: 'miles',
    design: 'navy-stars',
    last4: '7124',
    annualFee: 5000,
    feeWaiver: 0,
    pointValueINR: 1.0,
    currency: 'EDGE Miles',
    welcomeBonus: '5,000 EDGE Miles',
    bestFor: ['Travel', 'Flights', 'International'],
    rates: [
      { category: 'Travel (Direct)', rate: 5, unit: '5 EDGE miles per ₹100', cap: 200000 },
      { category: 'Travel (Other)', rate: 2, unit: '2 EDGE miles per ₹100', cap: 0 },
      { category: 'General', rate: 2, unit: '2 EDGE miles per ₹100', cap: 0 },
      { category: 'Fuel', rate: 0, unit: 'Excluded', cap: 0 },
      { category: 'Utilities', rate: 0, unit: 'Excluded', cap: 0 },
    ],
    milestones: [
      { name: 'Silver → Gold Tier', target: 750000, current: 612000, reward: '+5,000 EDGE Miles' },
      { name: 'Milestone Bonus', target: 300000, current: 286000, reward: '2,500 EDGE Miles' },
    ],
    benefits: ['8 domestic lounges/qtr', '4 intl lounges/yr', 'Tier upgrades'],
  },
  {
    id: 'card-amex-pt',
    bank: 'American Express',
    name: 'Platinum Travel',
    tier: 'Travel',
    network: 'AMEX',
    type: 'rewards',
    design: 'silver-metallic',
    last4: '3008',
    annualFee: 5000,
    feeWaiver: 0,
    pointValueINR: 0.5,
    currency: 'Membership Rewards',
    welcomeBonus: '10,000 MR Points',
    bestFor: ['Milestone spend', 'Travel vouchers'],
    rates: [
      { category: 'General', rate: 1, unit: '1 MR per ₹50', cap: 0 },
      { category: 'Milestone (₹1.9L)', rate: 0, unit: '15,000 MR Bonus', cap: 0 },
      { category: 'Milestone (₹4L)', rate: 0, unit: '25,000 MR + ₹10k voucher', cap: 0 },
    ],
    milestones: [
      { name: '₹1.9L Spend Bonus', target: 190000, current: 156000, reward: '15,000 MR' },
      { name: '₹4L Spend Bonus', target: 400000, current: 156000, reward: '25,000 MR + Taj voucher' },
    ],
    benefits: ['Travel vouchers', 'Lounge access', 'Hotel partner offers'],
  },
  {
    id: 'card-sbi-cashback',
    bank: 'SBI Card',
    name: 'Cashback',
    tier: 'Cashback',
    network: 'VISA',
    type: 'cashback',
    design: 'modern-teal',
    last4: '9921',
    annualFee: 999,
    feeWaiver: 200000,
    pointValueINR: 1.0,
    currency: 'Cashback (₹)',
    welcomeBonus: 'None',
    bestFor: ['Online shopping', 'Amazon', 'Flipkart', 'Myntra'],
    rates: [
      { category: 'Online', rate: 5, unit: '5% cashback', cap: 5000 },
      { category: 'Offline', rate: 1, unit: '1% cashback', cap: 0 },
      { category: 'Utilities', rate: 0, unit: 'Excluded', cap: 0 },
      { category: 'Fuel', rate: 0, unit: 'Excluded', cap: 0 },
      { category: 'Insurance', rate: 0, unit: 'Excluded', cap: 0 },
    ],
    milestones: [],
    benefits: ['Fuel surcharge waiver (₹100/mo)'],
  },
  {
    id: 'card-emeralde',
    bank: 'ICICI Bank',
    name: 'Emeralde Private Metal',
    tier: 'Premium',
    network: 'VISA',
    type: 'rewards',
    design: 'emerald-luxury',
    last4: '5588',
    annualFee: 12499,
    feeWaiver: 0,
    pointValueINR: 1.0,
    currency: 'Reward Points',
    welcomeBonus: '12,500 RP',
    bestFor: ['Insurance', 'Utilities (high spend)', 'Grocery', 'General'],
    rates: [
      { category: 'General', rate: 6, unit: '6 RP per ₹200', cap: 0 },
      { category: 'Insurance', rate: 6, unit: '6 RP per ₹200', cap: 100000 },
      { category: 'Utilities', rate: 6, unit: '6 RP per ₹200', cap: 40000 },
      { category: 'Grocery', rate: 6, unit: '6 RP per ₹200', cap: 40000 },
      { category: 'Fuel', rate: 0, unit: 'Excluded', cap: 0 },
    ],
    milestones: [
      { name: 'Taj Epicure Membership', target: 1000000, current: 412000, reward: 'Free Taj Epicure' },
    ],
    benefits: ['Unlimited intl lounges', '2 free golf rounds/mo', 'BookMyShow B1G1'],
  },
];

export const CATEGORIES = [
  'Dining', 'Travel', 'Flights', 'Fuel', 'Grocery', 'UPI', 'Utilities',
  'Insurance', 'Shopping', 'Amazon', 'Flipkart', 'International', 'Online', 'Offline', 'EMI',
];

export const MERCHANTS = [
  { slug: 'amazon', name: 'Amazon', category: 'Shopping', online: true, color: '#ff9900', initials: 'AM' },
  { slug: 'flipkart', name: 'Flipkart', category: 'Shopping', online: true, color: '#2874f0', initials: 'FK' },
  { slug: 'swiggy', name: 'Swiggy', category: 'Dining', online: true, color: '#fc8019', initials: 'SW' },
  { slug: 'zomato', name: 'Zomato', category: 'Dining', online: true, color: '#e23744', initials: 'ZO' },
  { slug: 'myntra', name: 'Myntra', category: 'Shopping', online: true, color: '#ff3f6c', initials: 'MY' },
  { slug: 'makemytrip', name: 'MakeMyTrip', category: 'Travel', online: true, color: '#eb2026', initials: 'MMT' },
  { slug: 'uber', name: 'Uber', category: 'Travel', online: true, color: '#000000', initials: 'UB' },
  { slug: 'indigo', name: 'IndiGo', category: 'Flights', online: true, color: '#11257c', initials: 'IG' },
  { slug: 'bigbasket', name: 'BigBasket', category: 'Grocery', online: true, color: '#84c225', initials: 'BB' },
  { slug: 'hdfc-ergo', name: 'HDFC Ergo', category: 'Insurance', online: true, color: '#003d7a', initials: 'HE' },
  { slug: 'tata-power', name: 'Tata Power', category: 'Utilities', online: true, color: '#1f4e8b', initials: 'TP' },
  { slug: 'hpcl', name: 'HPCL', category: 'Fuel', online: false, color: '#c8102e', initials: 'HP' },
];

export const MERCHANT_INTEL = {
  amazon: {
    bestCardId: 'card-sbi-cashback',
    bestReason: '5% cashback on online up to ₹5,000/qtr. After cap, switch to Infinia for grocery sub-category.',
    yourSpendYTD: 48200,
    yourRewardsYTD: 1924,
    tips: [
      'Use Amazon Pay ICICI for select Amazon deals (3% on Prime).',
      'Avoid using AmEx for Amazon — limited acceptance and lower rate.',
      'For grocery on Amazon Fresh, HDFC Infinia 3.3x is better than 1% cashback after cap.',
    ],
    cardRanks: [
      { cardId: 'card-sbi-cashback', rate: '5%', expected: '₹250 on ₹5K' },
      { cardId: 'card-infinia', rate: '3.3x', expected: '₹110 on ₹5K' },
      { cardId: 'card-emeralde', rate: '6 RP/₹200', expected: '₹150 on ₹5K' },
      { cardId: 'card-atlas', rate: '2x', expected: '₹100 on ₹5K' },
      { cardId: 'card-amex-pt', rate: '1x', expected: '₹100 on ₹5K (MR × 0.5)' },
    ],
  },
  swiggy: {
    bestCardId: 'card-infinia',
    bestReason: '5x RP per ₹150 on dining — effective ≈3.3% as reward value. Pair with Swiggy Bank Offer of the month.',
    yourSpendYTD: 18420,
    yourRewardsYTD: 614,
    tips: [
      'Pay via Swiggy app, not website, to be eligible for some bank offers.',
      'Avoid Atlas — dining is not an accelerated category.',
    ],
    cardRanks: [
      { cardId: 'card-infinia', rate: '5x RP', expected: '₹42 on ₹1,280' },
      { cardId: 'card-emeralde', rate: '6 RP/₹200', expected: '₹38 on ₹1,280' },
      { cardId: 'card-sbi-cashback', rate: '5% online', expected: '₹64 on ₹1,280 (Online cap)' },
      { cardId: 'card-atlas', rate: '2x', expected: '₹26 on ₹1,280' },
      { cardId: 'card-amex-pt', rate: '1x', expected: '₹13 on ₹1,280' },
    ],
  },
  makemytrip: {
    bestCardId: 'card-atlas',
    bestReason: 'Direct travel platform earns 5 EDGE Miles per ₹100 + nudges Silver → Gold tier milestone.',
    yourSpendYTD: 78340,
    yourRewardsYTD: 3917,
    tips: [
      'For hotel bookings, HDFC Infinia via SmartBuy can yield 10x RP — sometimes better than Atlas.',
      'Book flights on the airline’s own site to maximize Atlas accelerator.',
    ],
    cardRanks: [
      { cardId: 'card-atlas', rate: '5 EDGE/₹100', expected: '₹921 on ₹18,420' },
      { cardId: 'card-infinia', rate: '10x via SmartBuy', expected: '₹1,228 if booked via SmartBuy' },
      { cardId: 'card-emeralde', rate: '6 RP/₹200', expected: '₹553' },
      { cardId: 'card-sbi-cashback', rate: '5% online', expected: '₹5,000 cap depleting fast' },
      { cardId: 'card-amex-pt', rate: '1x + milestone', expected: '₹184 + milestone' },
    ],
  },
  'hdfc-ergo': {
    bestCardId: 'card-emeralde',
    bestReason: 'Insurance category caps at ₹1L for 6x earn — ≈3% as cashback equivalent. Beats Infinia (3.3x) on value once you account for valuation.',
    yourSpendYTD: 28000,
    yourRewardsYTD: 840,
    tips: [
      'Most cashback cards exclude insurance — don’t use SBI Cashback here.',
      'After ₹1L on Emeralde, use HDFC Infinia for the rest.',
    ],
    cardRanks: [
      { cardId: 'card-emeralde', rate: '6 RP/₹200', expected: '₹840 on ₹28K' },
      { cardId: 'card-infinia', rate: '3.3x RP', expected: '₹616 on ₹28K' },
      { cardId: 'card-atlas', rate: '2x', expected: '₹560' },
      { cardId: 'card-amex-pt', rate: '1x', expected: '₹280 (MR × 0.5)' },
      { cardId: 'card-sbi-cashback', rate: 'Excluded', expected: '₹0' },
    ],
  },
  flipkart: {
    bestCardId: 'card-sbi-cashback',
    bestReason: '5% online cashback (until quarterly cap). For big appliances during sales, look for Flipkart Axis Bank co-brand offers.',
    yourSpendYTD: 18920,
    yourRewardsYTD: 946,
    tips: [
      'During The Big Billion Days, instant discount offers may stack with cashback.',
      'Avoid Amex on Flipkart — 1x return is poor here.',
    ],
    cardRanks: [
      { cardId: 'card-sbi-cashback', rate: '5%', expected: '₹446 on ₹8,920' },
      { cardId: 'card-emeralde', rate: '6 RP/₹200', expected: '₹267 on ₹8,920' },
      { cardId: 'card-infinia', rate: '3.3x', expected: '₹196' },
      { cardId: 'card-atlas', rate: '2x', expected: '₹178' },
      { cardId: 'card-amex-pt', rate: '1x', expected: '₹89 (MR × 0.5)' },
    ],
  },
};

export const TRANSACTIONS = [
  { id: 't-001', merchant: 'MakeMyTrip', merchantSlug: 'makemytrip', category: 'Travel', amount: 18420, cardId: 'card-atlas', cardName: 'Axis Atlas', rewards: 921, rewardCurrency: 'EDGE Miles', rewardValue: 921, date: '2025-03-10T14:22:00', best: true },
  { id: 't-002', merchant: 'Swiggy', merchantSlug: 'swiggy', category: 'Dining', amount: 1280, cardId: 'card-infinia', cardName: 'HDFC Infinia', rewards: 42, rewardCurrency: 'RP', rewardValue: 42, date: '2025-03-10T20:11:00', best: true },
  { id: 't-003', merchant: 'Amazon', merchantSlug: 'amazon', category: 'Amazon', amount: 4990, cardId: 'card-sbi-cashback', cardName: 'SBI Cashback', rewards: 250, rewardCurrency: '₹', rewardValue: 250, date: '2025-03-09T11:34:00', best: true },
  { id: 't-004', merchant: 'HDFC Ergo', merchantSlug: 'hdfc-ergo', category: 'Insurance', amount: 28000, cardId: 'card-amex-pt', cardName: 'Amex Platinum Travel', rewards: 560, rewardCurrency: 'MR', rewardValue: 280, date: '2025-03-08T09:00:00', best: false, missed: 560, betterCard: 'ICICI Emeralde' },
  { id: 't-005', merchant: 'BigBasket', merchantSlug: 'bigbasket', category: 'Grocery', amount: 2840, cardId: 'card-infinia', cardName: 'HDFC Infinia', rewards: 62, rewardCurrency: 'RP', rewardValue: 62, date: '2025-03-07T18:45:00', best: true },
  { id: 't-006', merchant: 'Uber', merchantSlug: 'uber', category: 'Travel', amount: 612, cardId: 'card-atlas', cardName: 'Axis Atlas', rewards: 12, rewardCurrency: 'EDGE Miles', rewardValue: 12, date: '2025-03-07T08:20:00', best: true },
  { id: 't-007', merchant: 'Tata Power', merchantSlug: 'tata-power', category: 'Utilities', amount: 4400, cardId: 'card-emeralde', cardName: 'ICICI Emeralde', rewards: 132, rewardCurrency: 'RP', rewardValue: 132, date: '2025-03-06T12:00:00', best: true },
  { id: 't-008', merchant: 'IndiGo', merchantSlug: 'indigo', category: 'Flights', amount: 11200, cardId: 'card-atlas', cardName: 'Axis Atlas', rewards: 560, rewardCurrency: 'EDGE Miles', rewardValue: 560, date: '2025-03-05T16:14:00', best: true },
  { id: 't-009', merchant: 'Myntra', merchantSlug: 'myntra', category: 'Shopping', amount: 3290, cardId: 'card-sbi-cashback', cardName: 'SBI Cashback', rewards: 164, rewardCurrency: '₹', rewardValue: 164, date: '2025-03-04T22:08:00', best: true },
  { id: 't-010', merchant: 'Zomato', merchantSlug: 'zomato', category: 'Dining', amount: 820, cardId: 'card-infinia', cardName: 'HDFC Infinia', rewards: 27, rewardCurrency: 'RP', rewardValue: 27, date: '2025-03-03T21:35:00', best: true },
  { id: 't-011', merchant: 'HPCL', merchantSlug: 'hpcl', category: 'Fuel', amount: 3200, cardId: 'card-emeralde', cardName: 'ICICI Emeralde', rewards: 0, rewardCurrency: 'RP', rewardValue: 0, date: '2025-03-02T08:00:00', best: false, missed: 32, betterCard: 'Fuel co-brand' },
  { id: 't-012', merchant: 'Flipkart', merchantSlug: 'flipkart', category: 'Flipkart', amount: 8920, cardId: 'card-sbi-cashback', cardName: 'SBI Cashback', rewards: 446, rewardCurrency: '₹', rewardValue: 446, date: '2025-03-01T15:42:00', best: true },
];

export const SPEND_BY_CATEGORY = [
  { category: 'Travel', amount: 38432, color: 'hsl(var(--chart-1))' },
  { category: 'Dining', amount: 8420, color: 'hsl(var(--chart-2))' },
  { category: 'Shopping', amount: 12180, color: 'hsl(var(--chart-3))' },
  { category: 'Grocery', amount: 7920, color: 'hsl(var(--chart-4))' },
  { category: 'Insurance', amount: 28000, color: 'hsl(var(--chart-5))' },
  { category: 'Utilities', amount: 8800, color: 'hsl(var(--chart-1))' },
  { category: 'Fuel', amount: 6800, color: 'hsl(var(--chart-3))' },
];

export const REWARDS_TREND = [
  { month: 'Oct', cashback: 1240, points: 1870, miles: 980 },
  { month: 'Nov', cashback: 1480, points: 2120, miles: 1240 },
  { month: 'Dec', cashback: 1860, points: 2480, miles: 1580 },
  { month: 'Jan', cashback: 1320, points: 2240, miles: 1820 },
  { month: 'Feb', cashback: 1640, points: 2680, miles: 2120 },
  { month: 'Mar', cashback: 1280, points: 2840, miles: 2480 },
];

export const OPTIMIZATION_HISTORY = [
  { month: 'Oct', score: 68 },
  { month: 'Nov', score: 72 },
  { month: 'Dec', score: 78 },
  { month: 'Jan', score: 81 },
  { month: 'Feb', score: 84 },
  { month: 'Mar', score: 87 },
];

// Reward leakage events with severity and fix suggestions
export const LEAKAGE = [
  {
    id: 'lk-1',
    severity: 'high',
    title: 'HDFC Ergo insurance went on Amex (1x). Emeralde 6x would have earned 6× more.',
    category: 'Insurance',
    merchant: 'HDFC Ergo',
    usedCard: 'Amex Platinum Travel',
    suggestedCard: 'ICICI Emeralde Private Metal',
    value: 1400,
    date: '2025-03-08',
    fix: 'Set Emeralde as default for insurance auto-debits via biller registration.',
  },
  {
    id: 'lk-2',
    severity: 'medium',
    title: 'Fuel surcharge missed: Emeralde excludes fuel. Use a fuel co-brand for surcharge waiver.',
    category: 'Fuel',
    merchant: 'HPCL',
    usedCard: 'ICICI Emeralde',
    suggestedCard: 'IOCL HDFC RuPay or BPCL SBI',
    value: 320,
    date: '2025-03-02',
    fix: 'Add an IOCL/BPCL co-brand card; tag fuel as default in your rules.',
  },
  {
    id: 'lk-3',
    severity: 'low',
    title: 'Tata Power utility on Infinia (3.3x). Emeralde 6x cap not yet hit.',
    category: 'Utilities',
    merchant: 'Tata Power',
    usedCard: 'HDFC Infinia',
    suggestedCard: 'ICICI Emeralde Private Metal',
    value: 132,
    date: '2025-03-06',
    fix: 'Switch the biller default to Emeralde until ₹40K cap exhausts.',
  },
  {
    id: 'lk-4',
    severity: 'medium',
    title: 'Amazon spend on Infinia (3.3x) instead of SBI Cashback (5% online, cap free).',
    category: 'Amazon',
    merchant: 'Amazon',
    usedCard: 'HDFC Infinia',
    suggestedCard: 'SBI Cashback',
    value: 84,
    date: '2025-02-28',
    fix: 'Use SBI Cashback for routine Amazon spend; switch to Emeralde after quarterly cap.',
  },
  {
    id: 'lk-5',
    severity: 'low',
    title: 'Myntra payment on Amex (1x). SBI Cashback offers 5% online here.',
    category: 'Shopping',
    merchant: 'Myntra',
    usedCard: 'Amex Platinum Travel',
    suggestedCard: 'SBI Cashback',
    value: 62,
    date: '2025-02-22',
    fix: 'Default fashion sites to SBI Cashback until cap.',
  },
];

// Active offers
export const OFFERS = [
  {
    id: 'of-1',
    title: '15% off on flights',
    merchant: 'MakeMyTrip',
    merchantSlug: 'makemytrip',
    cardIds: ['card-atlas'],
    type: 'discount',
    category: 'Travel',
    desc: 'Use Axis Atlas on MMT domestic flights. Up to ₹1,500 off.',
    validTill: '2025-04-15',
    code: 'MMTATLAS',
    featured: true,
  },
  {
    id: 'of-2',
    title: '10% instant discount',
    merchant: 'Amazon',
    merchantSlug: 'amazon',
    cardIds: ['card-sbi-cashback', 'card-infinia'],
    type: 'discount',
    category: 'Shopping',
    desc: 'Min spend ₹5,000. Cap ₹1,000 per card per month.',
    validTill: '2025-03-31',
    code: 'AMZN10',
    featured: true,
  },
  {
    id: 'of-3',
    title: '5x reward points',
    merchant: 'Swiggy',
    merchantSlug: 'swiggy',
    cardIds: ['card-infinia'],
    type: 'accelerator',
    category: 'Dining',
    desc: 'Already part of HDFC Infinia structure. No code needed.',
    validTill: 'Ongoing',
  },
  {
    id: 'of-4',
    title: 'Buy 1 Get 1 BookMyShow',
    merchant: 'BookMyShow',
    merchantSlug: 'bookmyshow',
    cardIds: ['card-emeralde'],
    type: 'benefit',
    category: 'Entertainment',
    desc: '2 free tickets/mo on ICICI Emeralde Private Metal.',
    validTill: 'Ongoing',
  },
  {
    id: 'of-5',
    title: '₹1,500 off on bookings',
    merchant: 'Cleartrip',
    merchantSlug: 'cleartrip',
    cardIds: ['card-amex-pt'],
    type: 'discount',
    category: 'Travel',
    desc: 'Amex Platinum Travel · Min ₹15K domestic flight.',
    validTill: '2025-04-30',
    code: 'AMEXCT1500',
  },
  {
    id: 'of-6',
    title: '12% bonus on insurance',
    merchant: 'HDFC Ergo',
    merchantSlug: 'hdfc-ergo',
    cardIds: ['card-emeralde'],
    type: 'bonus',
    category: 'Insurance',
    desc: 'Use Emeralde to renew before Mar 31 for 12% extra RP.',
    validTill: '2025-03-31',
    featured: true,
  },
  {
    id: 'of-7',
    title: 'Free Uber Pro tier',
    merchant: 'Uber',
    merchantSlug: 'uber',
    cardIds: ['card-atlas'],
    type: 'benefit',
    category: 'Travel',
    desc: 'Free Uber Pro membership for Atlas cardholders.',
    validTill: 'Ongoing',
  },
  {
    id: 'of-8',
    title: '8% extra on Big Basket',
    merchant: 'BigBasket',
    merchantSlug: 'bigbasket',
    cardIds: ['card-infinia'],
    type: 'accelerator',
    category: 'Grocery',
    desc: 'Limited-time — ends in 6 days.',
    validTill: '2025-03-16',
    code: 'BBHDFC8',
  },
];

export const ASSISTANT_SUGGESTIONS = [
  'Which card should I use for insurance?',
  'Best card for international travel?',
  'Am I wasting rewards this month?',
  'How close am I to my Atlas tier?',
  'Compare HDFC Infinia vs ICICI Emeralde for utilities',
  'Best card for ₹4,200 on Swiggy?',
];
